<script setup lang="ts">
const { staticUrl } = useImageUrl();

interface Props {
  // When true, the loader covers the viewport (fixed overlay) instead of
  // sitting inline in the current layout slot. Use for "the whole page is
  // waiting on a fetch" states — e.g. filter result reloads on /search.
  fullScreen?: boolean;
}

withDefaults(defineProps<Props>(), {
  fullScreen: false,
});
</script>

<template>
  <div
    class="loading"
    :class="{ 'loading--full-screen': fullScreen }"
  >
    <img
      :src="staticUrl('/Images/gifs/and-dine-loading-pink.gif')"
      alt="loading"
    />
  </div>
</template>

<style lang="scss" scoped>
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 12.5rem;
  padding: 2rem 0;
  background-color: transparent;
  img {
    width: 5rem;
  }

  // Cover the viewport when invoked as a full-page state. Fixed
  // positioning keeps it above page chrome (navbar, footer, the
  // absolutely-positioned filter dropdown) so nothing pokes through.
  &--full-screen {
    position: fixed;
    inset: 0;
    z-index: 10000;
    background-color: var(--canvas-warm);
    min-height: 100vh;
    padding: 0;
  }
}
</style>
